export type TPlatform = 'tv_xboxone' | 'tv_samsung' | 'hbbtv' | 'web_browser'
export type TBrowser = 'safari' | 'device' | 'general'
export type TFormFactor = 'console' | 'tv' | 'tablet' | 'mobile' | 'desktop'

export interface XboxAppStaticInfo {
  appVersion: string
  deviceFamily: string
  deviceModel: string
  advertisingId: string | null
  isLAT: boolean
}

export enum TAdIsLat {
  TRUE = '1',
  FALSE = '0',
}

export interface TAdInfo {
  did: string
  is_lat: TAdIsLat
  device_make: string
  device_model: string
  platform: string
  osversion: string
}

export interface TWindowWithDeviceInfo {
  deviceInfo: TDeviceInfo
}

interface TWindowWithWebview2 {
  chrome?: {
    webview?: any
  }
  XboxAppStaticInfo?: XboxAppStaticInfo
}

// Minimal properties for identification only
interface TWindowWithDDRum {
  DD_RUM?: any
}

interface TWindowWithFirebolt {
  __firebolt?: any
}

export interface TDeviceInfo extends TNativeInfo {
  platform?: TPlatform
  browser?: TBrowser
  adInfo?: TAdInfo
  drmInfo?: TDrmInfo
  formFactor?: TFormFactor
  userAgent?: string
  uaBrowserVersion?: string
  deviceName?: TDeviceName
  apiVersion?: string
  osVersion?: string
  backButtonExits?: boolean
  showExitConfirmation?: boolean
}

export type TDeviceName =
  | 'Xbox'
  | 'iOS Device'
  | 'Mac'
  | 'Windows PC'
  | 'Android Device'
  | 'Samsung TV'
  | 'Comcast STB'
  | 'Unknown Device'

interface TNativeInfo {
  isLAT?: boolean
  deviceMake?: string
  deviceModel?: string
  nativeVersion?: string
  // If a device user opts-in to having one (xbox particularly), this should be an ID that identifies them.
  // Otherwise, this is a completely arbitrary ID that we will persist in localStorage.
  advertisingId?: string
}

export interface TDrmInfo {
  type: DRMType
  format: DRMFormat
}

type DRMType = 'widevine' | 'playready' | 'fairplay'
type DRMFormat = 'DASH' | 'HLS'

declare global {
  interface Window extends TWindowWithDeviceInfo, TWindowWithWebview2, TWindowWithDDRum, TWindowWithFirebolt {}
}
